import React, { useEffect, useState } from "react";
import "./ProgressBox.scss";
import { Box, LinearProgress, LinearProgressProps, Typography } from "@mui/material";

interface ProgressBoxProps {
  fileUploadProgress: number;
  fileUploadData: string;
}

function LinearProgressWithLabel(props: LinearProgressProps & { value: number }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant="body2" color="text.secondary">{`${Math.round(
          props.value,
        )}%`}</Typography>
      </Box>
    </Box>
  );
}

const ProgressBox: React.FC<ProgressBoxProps> = ({
  fileUploadProgress,
  fileUploadData,
}) => {
  const [pleaseWait, setPleaseWait] = useState(true);

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (fileUploadProgress === 100) {
      timer = setTimeout(() => {
        setPleaseWait(true);
      }, 20000); // 20 seconds
    } else {
      setPleaseWait(false);
    }
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [fileUploadProgress]);

  return (
    <div className="ProgressBox">
      <div className="ProgressBox__iconBox">
        <img src="/icons/uploadIcon.png" alt="uploadIcon" />
      </div>

      <div className="ProgressBox__infoContainer">
        <div className="infoBar">
          <p className="infoBar__title">{pleaseWait? 'Please Wait CID generation in process, this can take sometime ....':fileUploadData}</p>
        <LinearProgressWithLabel value={fileUploadProgress} />
        </div>
      </div>
    </div>
  );
};

export default ProgressBox;
